<template>
  <table class="table table-bordered table-hover align-middle">
    <thead
      v-if="currentUsergroupIndexers && currentUsergroupIndexers.length"
      class="table-dark"
    >
      <tr>
        <th scope="col">
          {{ $t('indexers.table.name') }}
        </th>
        <th scope="col">
          {{ $t('indexers.table.implementation') }}
        </th>
        <th scope="col">
          {{ $t('indexers.table.date') }}
        </th>
        <th
          scope="col"
          style="text-align: center;"
        >
          {{ $t('indexers.table.status') }}
        </th>
        <th
          scope="col"
          style="text-align: center;"
        >
          {{ $t('buttons.delete') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="indexer of currentUsergroupIndexers"
        :key="`indexer-${indexer.id}`"
        @click="$router.push({
          name: 'IndexerDetail',
          params: {
            usergroupId: usergroupId,
            indexerId: indexer.id
          }
        })"
      >
        <td>
          {{ indexer.name }}
        </td>
        <td>
          {{ indexer.command }}
        </td>
        <td>
          {{ new Date(indexer.creation_date).toLocaleDateString() }}
        </td>
        <td style="text-align: center;">
          <i
            v-if="indexer.active"
            class="bi bi-patch-check text-success"
            style="font-size: 1rem;"
          />
        </td>
        <td style="text-align: center;">
          <img
            class="delete-icon"
            src="@/assets/icons/trash_delete.svg"
            alt="Icon trash delete"
            @click.stop="deleteIndexer(indexer.id)"
          >
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'IndexersTable',

  props: {
    usergroupId: {
      type: Number, String,
      required: true
    }
  },

  computed: {
    ...mapState('indexers', [
      'currentUsergroupIndexers'
    ])
  },

  watch: {
    usergroupId: {
      immediate: true,
      handler() {
        this.loadIndexers();
      }
    }
  },

  methods: {
    ...mapActions('indexers', [
      'GET_USERGROUP_INDEXERS',
      'DELETE_INDEXER'
    ]),

    async loadIndexers() {
      if (!this.usergroupId) {
        return;
      }
      try {
        this.$emit('loading', true);
        await this.GET_USERGROUP_INDEXERS(this.usergroupId);
      } finally {
        this.$emit('loading', false);
      }
    },

    async deleteIndexer(indexerId) {
      try {
        this.$emit('loading', true);
        await this.DELETE_INDEXER({
          indexerId: indexerId,
          usergroupId: this.usergroupId
        });
        this.$emit('loading', false);
      } catch {
        this.$emit('loading', false);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.table {
  thead {
    tr {
      th {
        font-size: 0.9em;
        padding: 0.4rem;
      }
    }
  }
  tbody {
    tr {
      cursor: pointer;
      td {
        padding: 0.4rem;
        font-size: 0.8em;
        line-height: 1rem;
        vertical-align: middle;
        .indexer-status {
          height: 1rem;
          width: 1rem;
          border-radius: 50%;
          background-color: red;
        }
        .indexer-status.active {
          background-color: green;
        }
        .delete-icon {
          cursor: pointer;
          width: 1.75em;
          height: 1.2rem;
        }
        .delete-icon:hover {
          transform: scale(1.1);
        }
      }
      td:first-child {
        font-weight: bold;
      }
    }
  }
}
</style>